function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext } from "react";
import { TableBatchAction, TableBatchActions, TableToolbar, TableToolbarContent, TableToolbarSearch } from "@carbon/react";
import { TrashCan } from "@carbon/react/icons";
import { i18nContext } from "./table-context";
import { format } from "../../utils/locales";
import AddPropertyBtn from "./AddPropertyBtn";
function PropertyTableHeader(_ref) {
  var addProperty = _ref.addProperty,
    enableAppConfig = _ref.enableAppConfig,
    filterPlaceholder = _ref.filterPlaceholder,
    getBatchActionProps = _ref.getBatchActionProps,
    handleDelete = _ref.handleDelete,
    hideSearch = _ref.hideSearch,
    onInputChange = _ref.onInputChange,
    persistentSearch = _ref.persistentSearch,
    readonly = _ref.readonly,
    selectedRows = _ref.selectedRows;
  var i18n = useContext(i18nContext);
  var handleAddProperty = function handleAddProperty(type) {
    addProperty(type);
  };
  var translateIds = function translateIds(id, state) {
    switch (id) {
      case "carbon.table.batch.item.selected":
        return i18n.messages.tableItemSelected;
      case "carbon.table.batch.items.selected":
        return format(i18n.messages.tableItemsSelected, [state.totalSelected]);
      case "carbon.table.batch.cancel":
        return i18n.messages.carbonTableBatchCancel;
      default:
        return "";
    }
  };
  return /*#__PURE__*/React.createElement(TableToolbar, null, !readonly && getBatchActionProps && /*#__PURE__*/React.createElement(TableBatchActions, _extends({
    translateWithId: translateIds
  }, getBatchActionProps()), /*#__PURE__*/React.createElement(TableBatchAction, {
    iconDescription: i18n.messages.propertyDelete,
    renderIcon: TrashCan,
    onClick: function onClick() {
      return handleDelete(selectedRows, getBatchActionProps().onCancel);
    },
    tabIndex: getBatchActionProps().shouldShowBatchActions ? 0 : -1
  }, i18n.messages.propertyDelete)), /*#__PURE__*/React.createElement(TableToolbarContent, null, /*#__PURE__*/React.createElement(TableToolbarSearch, {
    "aria-label": filterPlaceholder || i18n.messages.search,
    labelText: filterPlaceholder || i18n.messages.search,
    onChange: onInputChange,
    persistent: !hideSearch && persistentSearch,
    placeholder: filterPlaceholder || i18n.messages.search
  }), !readonly && /*#__PURE__*/React.createElement(AddPropertyBtn, {
    addProperty: handleAddProperty,
    buttonName: i18n.messages.propertyAdd,
    enableAppConfig: enableAppConfig,
    title: i18n.messages.propertyAddTitle
  })));
}
export default PropertyTableHeader;